export default {
    WIFI: 'WIFI',
};
